// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__d0aiB","inputWrap":"styles_inputWrap__3KguR","input":"styles_input__1htG3"};